import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getResourcecategories, getResourcecategoriesOptions } from '../../../../../redux/actions/resourcecategories'
import { getResourcetypes } from '../../../../../redux/actions/resourcetypes'
import { IRootState } from '../../../../../redux/types'
import { IResource } from '../../models/resource'
import { IVisibility } from '@/contexts/backoffice/courses/models/course'

function useEditMediaState() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { globalCountriesId, globalLanguageId, globalFamilyId, globalBrandId } = useSelector((state: IRootState) => state.global)
  const { resourceSelected } = useSelector((state: IRootState) => state.resource)
  const { resourcetypes } = useSelector((state: IRootState) => state.resourcetype)

  const VISIBILITY: IVisibility[] = [
    { id: 0, name: t('private') },
    { id: 1, name: 'VIP' },
    { id: 2, name: t('public') }
  ]

  const [resource, setResource] = useState<IResource>({
    id: resourceSelected.id,
    fileName: resourceSelected.file_name,
    cover: resourceSelected.cover,
    brand: resourceSelected.brand,
    line: resourceSelected.line,
    resourcetypes: resourceSelected.resourcetypes || [],
    categories: resourceSelected.categories || [],
    countries: resourceSelected.countries.map((country: any) => country.id),
    role: resourceSelected.role,
    languages: resourceSelected.languages.map((language: any) => language.id),
    visibility: VISIBILITY.find((v: any) => v.id === resourceSelected.visibility) || VISIBILITY[0],
    description: resourceSelected.description,
    alias: resourceSelected.alias
  })

  const handleInputChange = (inputName: string, value: any) => {
    if (inputName === 'brand') {
      setResource({ ...resource, brand: value })
      if (value !== null) {
        dispatch(
          getResourcecategoriesOptions({
            languageId: globalLanguageId,
            countriesId: globalCountriesId,
            familyId: null,
            brandId: value
          })
        )
      }
    } else {
      setResource({ ...resource, [inputName]: value })
    }
  }

  useEffect(() => {
    if (resourceSelected !== null && resourceSelected.id !== resource.id) {
      setResource({
        id: resourceSelected.id,
        fileName: resourceSelected.file_name,
        cover: resourceSelected.cover,
        brand: resourceSelected.brand || null,
        line: resourceSelected.line || null,
        resourcetypes: resourceSelected.resourcetypes || [],
        categories: resourceSelected.categories || [],
        role: resourceSelected.role || null,
        countries: resourceSelected.countries.map((country: any) => country.id) || [],
        languages: resourceSelected.languages.map((language: any) => language.id) || [],
        visibility: VISIBILITY.find((v: any) => v.id === resourceSelected.visibility) || VISIBILITY[0],
        alias: resourceSelected.alias,
        description: resourceSelected.description
      })
    }
  }, [resourceSelected])

  useEffect(() => {
    if (globalLanguageId !== null) {
      if (resourcetypes.length === 0) dispatch(getResourcetypes())

      if (resourcetypes.length === 0)
        dispatch(
          getResourcecategories({
            languageId: globalLanguageId,
            countriesId: globalCountriesId,
            familyId: globalFamilyId,
            brandId: globalBrandId
          })
        )
    }
  }, [globalLanguageId])

  return { resource, handleInputChange, VISIBILITY }
}

export default useEditMediaState
